import styles from '../player.module.scss';
import __isEmpty from 'lodash/isEmpty';
import CodiEspectador from '../../CodiEspectador';

export default function InfoVideo(props) {
    const { edat, descriptors } = props;
    const codiEdat = edat?.replace('CE_', '').replace(/^0+/, '');
    const altEdat = codiEdat && !isNaN(codiEdat) ? `${codiEdat} anys` : '';
    const descriptorsList = Array.isArray(descriptors)
        ? descriptors
        : typeof descriptors === 'string'
          ? descriptors
                .split(',')
                .map((descriptor) => descriptor.trim())
                .filter(Boolean)
          : [];

    return (
        <div className={styles.infoVideoWrapper}>
            {edat !== 'CE_TP' && !__isEmpty(edat) && (
                <span className={styles.edat}>
                    <CodiEspectador codi={edat} alt={altEdat} mida='24' />
                </span>
            )}
            {!__isEmpty(descriptorsList) && (
                <div className={styles.descriptors}>
                    {descriptorsList.map((descriptor, index) => (
                        <span key={`${descriptor}-${index}`} className={styles.descriptorItem}>
                            <span className={styles.descriptorText}>{descriptor}</span>
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
}
